import { useEffect, useRef, useState } from 'react';

import { copyToClipboard } from './copyToClipboard';

// Alternative to useCopy, where the copy text is provided as an argument

export function useCopyAction() {
  const [copied, setCopied] = useState(false);

  const timerRef = useRef<number>();
  const onCopy = (copy: string) => {
    window.clearTimeout(timerRef.current);
    copyToClipboard(copy);
    setCopied(true);
    timerRef.current = window.setTimeout(() => setCopied(false), 2000);
  };

  useEffect(() => {
    return () => window.clearTimeout(timerRef.current);
  }, []);

  return { copied, onCopy };
}

export function useCopy(props?: { copy?: string }) {
  const [copied, setCopied] = useState(false);

  const timerRef = useRef<number>();
  const onCopy = () => {
    window.clearTimeout(timerRef.current);
    copyToClipboard(props?.copy);
    setCopied(true);
    timerRef.current = window.setTimeout(() => setCopied(false), 2000);
  };

  useEffect(() => {
    return () => window.clearTimeout(timerRef.current);
  }, []);

  return { copied, onCopy };
}
